import React, { useState } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import "../CreateNewPasswordA/CreateNewPassword.css";
import PasswordChangedPopup from "../../components/PasswordChangedPopup/PasswordChangedPopup";
import { API_URL } from "../../constant";

const CreateNewPassword = () => {
  const [formData, setFormData] = useState({ newPassword: "", confirmPassword: "" });
  const [showPopup, setShowPopup] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [isLoading, setIsLoading] = useState(false);

  const containerStyle = { minHeight: "100vh", fontFamily: "Arial, sans-serif", display: "flex", flexDirection: "column", justifyContent: "space-between", marginTop: "30px" };
  const formWrapperStyle = { display: "flex", justifyContent: "center", padding: "0px", flex: 1, boxSizing: "border-box", marginTop: "120px", width: "100%", marginBottom: "120px" };
  const formCardStyle = { backgroundColor: "#ffffff", padding: "32px", borderRadius: "17.6px", width: "100%", maxWidth: "1500px", boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)", boxSizing: "border-box" };
  const headingStyle = { textAlign: "center", fontSize: "28px", fontWeight: "900", marginBottom: "4px", background: "linear-gradient(90deg, #2D4CA8 52%, #9F4AFF 60%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" };
  const subheadingStyle = { textAlign: "center", color: "#696969", fontWeight: "normal", fontSize: "16px", marginBottom: "24px" };
  const labelStyle = { fontWeight: "600", fontSize: "14px", color: "#052C65", marginBottom: "6px", display: "block" };
  const inputRowStyleChild = { flex: "1", marginBottom: "24px", minWidth: "200px" };
  const inputStyle = { width: "100%", height: "40px", padding: "9px", borderRadius: "12px", border: "1px solid #ccc", fontSize: "14px", boxSizing: "border-box" };
  const buttonContainerStyle = { display: "flex", justifyContent: "center", gap: "15%", marginTop: "60px", marginBottom: "60px" };
  const primaryButtonStyle = { width: "auto", padding: "12px 32px", backgroundColor: "#0000A0", color: "#fff", border: "none", borderRadius: "10px", fontWeight: "500", cursor: "pointer", fontSize: "16px" };
  const messageStyle = { textAlign: "center", padding: "10px", borderRadius: "8px", margin: "20px 0", fontWeight: "500" };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (message.text) setMessage({ text: "", type: "" });
  };

  const validateForm = () => {
    if (!formData.newPassword || !formData.confirmPassword) { setMessage({ text: "Please fill in all fields", type: "error" }); return false; }
    if (formData.newPassword.length < 8) { setMessage({ text: "Password must be at least 8 characters long", type: "error" }); return false; }
    if (formData.newPassword !== formData.confirmPassword) { setMessage({ text: "Passwords do not match", type: "error" }); return false; }
    const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/;
    if (!strongRegex.test(formData.newPassword)) { setMessage({ text: "Password should include uppercase, lowercase, number and special character", type: "error" }); return false; }
    return true;
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    setIsLoading(true);
    setMessage({ text: "", type: "" });
    try {
      const email = localStorage.getItem("reset_email");
      const otp = localStorage.getItem("reset_otp");
      if (!email || !otp) { setMessage({ text: "Session expired. Please restart the password reset process.", type: "error" }); setIsLoading(false); return; }
      const response = await fetch(`${API_URL}/api/member/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ email, otp, password: formData.newPassword, password_confirmation: formData.confirmPassword }),
      });
      const data = await response.json();
      if (response.ok) { setShowPopup(true); localStorage.removeItem("reset_email"); localStorage.removeItem("reset_otp"); localStorage.removeItem("reset_token"); }
      else { setMessage({ text: data.message || data.errors?.password?.[0] || "Failed to update password.", type: "error" }); }
    } catch (error) { setMessage({ text: "An error occurred. Please try again.", type: "error" }); }
    finally { setIsLoading(false); }
  };

  return (
    <div style={{ ...containerStyle, minHeight: "auto" }}>
      <Header />
      <div style={formWrapperStyle}>
        <div className="form-card p-3 m-3 pt-4 h-auto" style={{ ...formCardStyle, minHeight: "auto" }}>
          <h2 style={headingStyle}>Create New Password</h2>
          <p style={subheadingStyle}>Your new password must be different from previously used passwords.</p>
          {message.text && (<div style={{ ...messageStyle, backgroundColor: message.type === "error" ? "#ffebee" : "#e8f5e9", color: message.type === "error" ? "#c62828" : "#2e7d32" }}>{message.text}</div>)}
          <div className="inputfieldcontainer gap-1 gap-md-3 mb-3">
            <div style={inputRowStyleChild}>
              <label style={labelStyle}>New Password</label>
              <input type="password" name="newPassword" placeholder="Enter your password" value={formData.newPassword} onChange={handleInputChange} style={inputStyle} disabled={isLoading}  maxLength={255} />
            </div>
            <div style={inputRowStyleChild}>
              <label style={labelStyle}>Confirm Password</label>
              <input type="password" name="confirmPassword" placeholder="Re-enter your password" value={formData.confirmPassword} onChange={handleInputChange} style={inputStyle} disabled={isLoading}  maxLength={255} />
            </div>
          </div>
          <div style={buttonContainerStyle} className="button-container">
            <button style={{ ...primaryButtonStyle, opacity: isLoading ? 0.7 : 1, cursor: isLoading ? "not-allowed" : "pointer" }} className="primary-button" onMouseOver={(e) => !isLoading && (e.target.style.backgroundColor = "#1a1aa0")} onMouseOut={(e) => !isLoading && (e.target.style.backgroundColor = "#0000A0")} onClick={handleUpdate} disabled={isLoading}>{isLoading ? "Updating..." : "Update Password"}</button>
          </div>
        </div>
      </div>
      {showPopup && <PasswordChangedPopup onClose={() => setShowPopup(false)} />}
      <Footer />
    </div>
  );
};

export default CreateNewPassword;
